module.exports = __webpack_public_path__ + "img/technical-prevention-bg.d87478a5.png";